module.exports = __webpack_public_path__ + "media/media/shop/item-1-689eaa0c77944c3ece04e59b58d07216.png";